import { ILinkProps } from '@cian/ui-kit';
import type { IBaseButtonProps } from '@cian/ui-kit/button/types';

export const DEFAULT_LINK_BUTTON_PROPS:
  | Pick<IBaseButtonProps, 'size' | 'fullWidth'>
  | Pick<ILinkProps, 'target' | 'rel'> = {
  size: 'L',
  fullWidth: true,
  target: '_blank',
  rel: 'noopener noreferrer',
};
